import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { ConclusionServiceModel, ServiceModelDto } from '../../../domain/models'
import {
  fetchConclusionService,
  fetchValidateReport,
  saveValidateReport,
  fetchValidateAttest,
  saveValidateAttest,
  fetchValidateDeclaration,
  saveValidateDeclaration
} from '../../../main/usecases'

import { dateToday } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import { Button, Input, SelectInput } from '..'
import { AssessmentModel } from '../../../domain/models/assessment'

type ValidadeReportFormModel = {
  assessment?: AssessmentModel | any
  idCustomer?: any
  type: string
  service?: ServiceModelDto
}

const ValidadeReportForm = ({
  assessment,
  idCustomer,
  type,
  service
}: ValidadeReportFormModel) => {
  const [conclusionToService, setConclusionToService] =
    useState<ConclusionServiceModel[]>()
  const [data, setData] = useState({
    conclusoes: {
      cdConclusaoServico: null,
      conclusaoServico: ''
    },
    dataFinal: dateToday,
    psicologo: {
      crp: '',
      municipio: ''
    }
  })
  const { setRefresh } = useOnChangeDetect()
  const { modalClose } = useModalBox()
  const alert = useAlert()

  const optionsConclusionService = useMemo(
    () =>
      conclusionToService?.map((item) => {
        return {
          value: item?.cdConclusaoAvaliacao,
          label: item?.conclusaoAvaliacao
        }
      }),
    [conclusionToService]
  )
  console.log(assessment)
  useEffect(() => {
    ;(async () => {
      try {
        const responseToConclusionService =
          await fetchConclusionService().load()
        setConclusionToService(responseToConclusionService)

        switch (type) {
          case 'laudo':
            const responseToValidateReport = await fetchValidateReport({
              id: assessment?.cdAvaliacaoPsicologica
            }).load()

            setData(responseToValidateReport)
            break
          case 'atestado':
            const responseToValidateAttest = await fetchValidateAttest({
              id: assessment?.cdAvaliacaoPsicologica
            }).load()

            setData(responseToValidateAttest)
            break

          case 'declaração':
            const responseToValidateDeclaration =
              await fetchValidateDeclaration({
                id: assessment?.cdAvaliacaoPsicologica
              }).load()

            setData(responseToValidateDeclaration)
            break
          default:
            alert.show(`Erro ao validar o ${type}`, {
              type: 'error',
              timeout: 4000
            })
            break
        }
      } catch (error) {
        console.error(error)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessment?.cdServico, type, alert])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      conclusaoAvaliacao: {
        cdConclusaoAvaliacao: Number(data.conclusoes.cdConclusaoServico),
        conclusaoAvaliacao: conclusionToService?.find(
          (item) =>
            String(item.cdConclusaoAvaliacao) ===
            String(data.conclusoes.cdConclusaoServico)
        )?.conclusaoAvaliacao
      },
      psicologo: {
        crp: data.psicologo.crp,
        municipio: data.psicologo.municipio
      },
      dataFinal: !data.dataFinal ? dateToday : data.dataFinal
    }

    try {
      switch (type) {
        case 'laudo':
          await saveValidateReport({
            id: assessment?.cdAvaliacaoPsicologica
          }).post(body)
          break
        case 'atestado':
          await saveValidateAttest({
            id: assessment?.cdAvaliacaoPsicologica
          }).post(body)
          break
        case 'declaração':
          await saveValidateDeclaration({
            id: assessment?.cdAvaliacaoPsicologica
          }).post(body)
          break
        default:
          alert.show(`Erro ao validar o ${type}`, {
            type: 'error',
            timeout: 4000
          })
          break
      }
      modalClose(true)
      alert.show('Validação criada com sucesso', {
        type: 'success',
        timeout: 4000
      })
      // goToUrl(
      //   history,
      //   `/meus-pacientes/${idCustomer}/prontuario?serviceId=${service?.cdServico}`
      // )
      setRefresh((prev: boolean) => !prev)
    } catch (error) {
      console.error(error)
      alert.show(`Erro ao validar o ${type}`, {
        type: 'error',
        timeout: 4000
      })
    }
  }

  return (
    <form className="validate-report-modal" onSubmit={onSubmit}>
      <h3>
        Estas são as informações essenciais para criação do {type}. Você pode
        preenchê-las agora.
      </h3>
      {(!assessment?.aplicacaoTeste?.realizado ||
        !assessment?.entrevista?.realizado ||
        !assessment?.observacaoComportamental?.realizado) &&
        type === 'laudo' && (
          <div className="warnings-container">
            Informações que faltam:
            {!assessment.entrevista?.realizado && (
              <Link
                to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/entrevista/${assessment.cdServico}`}
                onClick={() => modalClose(true)}
              >
                Entrevista Psicológica
              </Link>
            )}
            {!assessment.aplicacaoTeste?.realizado && (
              <Link
                to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/aplicacao-de-teste/${assessment.cdServico}`}
                onClick={() => modalClose(true)}
              >
                Aplicação de Teste
              </Link>
            )}
            {!assessment.observacaoComportamental?.realizado && (
              <Link
                to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/observacao-comportamental/${assessment.cdServico}`}
                onClick={() => modalClose(true)}
              >
                Observação Comportamental
              </Link>
            )}
          </div>
        )}
      <div>
        <Input
          labelColor="#4F4F4F"
          label="Município*"
          name="county"
          type="text"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              psicologo: {
                ...prev.psicologo,
                municipio: e.target.value
              }
            }))
          }
          value={data?.psicologo?.municipio}
          required
        />
        <Input
          labelColor="#4F4F4F"
          label="Data*"
          name="date"
          type="date"
          max={'2222-10-29'}
          onChange={(e: any) =>
            setData((prev) => ({ ...prev, dataFinal: e.target.value }))
          }
          value={data?.dataFinal}
          required
        />
        <Input
          labelColor="#4F4F4F"
          label="CRP*"
          name="crp"
          type="text"
          onChange={(e: any) =>
            setData((prev: any) => ({
              ...prev,
              psicologo: {
                ...prev.psicologo,
                crp: e.target.value
              }
            }))
          }
          value={data?.psicologo?.crp}
          required
        />
        <SelectInput
          labelColor="#4F4F4F"
          label="Conclusão*"
          name="conclusion"
          onChange={(e: any) =>
            setData((prev) => ({
              ...prev,
              conclusoes: {
                ...prev.conclusoes,
                cdConclusaoServico: e.target.value
              }
            }))
          }
          options={optionsConclusionService}
          value={data?.conclusoes?.cdConclusaoServico || ''}
          required
        />
      </div>
      <div className="buttons-container">
        <Button>Salvar e continuar</Button>
        <button
          className="access-complete-register-button"
          onClick={() => modalClose(true)}
        >
          <Link
            to={`/meus-pacientes/${idCustomer}/${
              service?.cdServico
            }/avaliacao-psicologica/${
              type === 'declaração' ? 'declaracao' : type
            }/${assessment.cdAvaliacaoPsicologica}`}
          >
            Ver {type}
          </Link>
        </button>
      </div>
    </form>
  )
}

export default ValidadeReportForm
